import React from 'react';
import cx from 'classnames';

import styles from './MaxlengthTextarea.less';

type MaxlengthTextareaProps = React.DetailedHTMLProps<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> & { maxLength: number; value: string };

/**
 * Shows the remaining character count once you've typed maxLength/2 characters.
 */
export const MaxlengthTextarea: React.FunctionComponent<MaxlengthTextareaProps> = function MaxlengthTextarea(
  props,
) {
  const { value, maxLength } = props;

  return (
    <>
      <textarea {...props} />
      <div
        className={cx(styles.lengthWarning, {
          [styles.show]: value.length > maxLength / 2,
        })}
      >
        {maxLength - value.length}
      </div>
    </>
  );
};
